module.exports = __webpack_public_path__ + "img/icon-play.a13d810e.svg";